export enum Errors {
  USER_UNDEFINED = 'User is not defined',
  USER_OR_PROJECT_UNDEFINED = 'User or Project is not defined',
  USER_PROJECT_OR_ASSET_UNDEFINED = 'User, Project, or Asset is undefined',
}
